import Extend from 'flarum/common/extenders';
import FlagUserPage from '../forum/components/FlagUserPage';

export default [
  new Extend.Routes()
    .add('user.flags', '/u/:username/flags', FlagUserPage),
];
